import styled, { css } from 'styled-components';
import Colors from '@components/shared/Colors';

export const TYPOGRAPHY_MOBILE_BREAKPOINT = 768;

export enum TextVariant {
  Heading1 = 'Heading1',
  Heading2 = 'Heading2',
  Heading3 = 'Heading3',
  Heading4 = 'Heading4',
  Heading5 = 'Heading5',
  Heading6 = 'Heading6',
  Heading7 = 'Heading7',
  Heading8 = 'Heading8',
  Heading9 = 'Heading9',
  Heading10 = 'Heading10',
  UpperText1 = 'UpperText1',
  UpperText2 = 'UpperText2',
  UpperText3 = 'UpperText3',
  UpperText4 = 'UpperText4',
  UpperText5 = 'UpperText5',
  UpperText6 = 'UpperText6',
  BodyRegularSM = 'BodyRegularSM',
  BodyRegularMD = 'BodyRegularMD',
  BodyRegularLG = 'BodyRegularLG',
  BodyRegularXL = 'BodyRegularXL',
  BodyBoldSM = 'BodyBoldSM',
  BodyBoldMD = 'BodyBoldMD',
  BodyBoldLG = 'BodyBoldLG',
  BodyBoldXL = 'BodyBoldXL'
}

export const TEXT_STYLES = {
  [TextVariant.Heading1]: css`
    font-family: 'Domaine';
    font-size: 64px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%; /* 83.2px */
    letter-spacing: -1.28px;
  `,
  [TextVariant.Heading2]: css`
    font-family: 'Domaine';
    font-size: 56px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%; /* 72.8px */
    letter-spacing: -0.56px;
  `,
  [TextVariant.Heading3]: css`
    font-family: 'Domaine';
    font-size: 48px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 67.2px */
    letter-spacing: -0.48px;
  `,
  [TextVariant.Heading4]: css`
    font-family: 'Domaine';
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 56px */
    letter-spacing: -0.4px;
  `,
  [TextVariant.Heading5]: css`
    font-family: 'Domaine';
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 44.8px */
    letter-spacing: -0.32px;
  `,
  [TextVariant.Heading6]: css`
    font-family: 'Domaine';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 33.6px */
    letter-spacing: -0.24px;
  `,
  [TextVariant.Heading7]: css`
    font-family: 'Domaine';
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 28px */
    letter-spacing: -0.2px;
  `,
  [TextVariant.Heading8]: css`
    font-family: 'Domaine';
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 22.4px */
    letter-spacing: -0.16px;
  `,
  [TextVariant.Heading9]: css`
    font-family: 'Domaine';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 19.6px */
    letter-spacing: -0.14px;
  `,
  [TextVariant.Heading10]: css`
    font-family: 'Domaine';
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 16.8px */
    letter-spacing: -0.12px;
  `,
  [TextVariant.UpperText1]: css`
    font-family: BrownStd;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 28.8px */
    letter-spacing: 1.5px;
    text-transform: uppercase;
  `,
  [TextVariant.UpperText2]: css`
    font-family: BrownStd;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 24px */
    letter-spacing: 1.5px;
    text-transform: uppercase;
  `,
  [TextVariant.UpperText3]: css`
    font-family: BrownStd;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 19.2px */
    letter-spacing: 1.5px;
    text-transform: uppercase;
  `,
  [TextVariant.UpperText4]: css`
    font-family: BrownStd;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 16.8px */
    letter-spacing: 1.5px;
    text-transform: uppercase;
  `,
  [TextVariant.UpperText5]: css`
    font-family: BrownStd;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 14.4px */
    letter-spacing: 1.5px;
    text-transform: uppercase;
  `,
  [TextVariant.UpperText6]: css`
    font-family: BrownStd;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 12px */
    letter-spacing: 1.5px;
    text-transform: uppercase;
  `,
  [TextVariant.BodyRegularSM]: css`
    font-family: BrownStd;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 16.8px */
  `,
  [TextVariant.BodyRegularMD]: css`
    font-family: BrownStd;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */
  `,
  [TextVariant.BodyRegularLG]: css`
    font-family: BrownStd;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 22.4px */
  `,
  [TextVariant.BodyRegularXL]: css`
    font-family: BrownStd;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 25.2px */
  `,
  [TextVariant.BodyBoldSM]: css`
    font-family: BrownStd;
    font-size: 12px;
    font-style: normal;
    line-height: 140%; /* 16.8px */
    font-weight: 700;
  `,
  [TextVariant.BodyBoldMD]: css`
    font-family: BrownStd;
    font-size: 14px;
    font-style: normal;
    line-height: 140%; /* 19.6px */
    font-weight: 700;
  `,
  [TextVariant.BodyBoldLG]: css`
    font-family: BrownStd;
    font-size: 16px;
    font-style: normal;
    line-height: 140%; /* 22.4px */
    font-weight: 700;
  `,
  [TextVariant.BodyBoldXL]: css`
    font-family: BrownStd;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%; /* 25.2px */
  `
};

interface Props {
  $variant: keyof typeof TEXT_STYLES;
  $mobileVariant?: keyof typeof TEXT_STYLES;
  $color?: string;
  $breakpoint?: number;
  $opacity?: number;
  as?: keyof JSX.IntrinsicElements;
}

export const Typography = styled.p<Props>`
  color: ${(props) => props.$color || Colors.navyBlue};
  opacity: ${(props) => props.$opacity || 1};
  ${(props) => TEXT_STYLES[props.$variant]};
  @media (max-width: ${(props) => props.$breakpoint || TYPOGRAPHY_MOBILE_BREAKPOINT}px) {
    ${(props) => (props.$mobileVariant ? TEXT_STYLES[props.$mobileVariant] : '')}
  }
`;
